import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { enumDropdownActionIconColor, enumDropdownActionMenuMode } from '../../enums';

@Component({
  selector: 'dropdown-action',
  templateUrl: './dropdown-action.component.html',
  styleUrls: ['./dropdown-action.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DropdownActionComponent implements OnInit {
  @Input() public id = 'dropdownMenu';
  @Input() public iconColor: enumDropdownActionIconColor = enumDropdownActionIconColor.DEFAULT;
  @Input() public menuMode: enumDropdownActionMenuMode = enumDropdownActionMenuMode.DEFAULT;
  @Input() public className = 'ml-2';
  @Input() public placement: string = 'bottom right';
  @Input() public isCustomButton: boolean = false;

  public enumDropdownActionMenuMode: typeof enumDropdownActionMenuMode = enumDropdownActionMenuMode;

  constructor() {}

  public ngOnInit(): void {}
}
